export const COMMUNITY_MODERATOR_PERMISSION_OPTIONS = [
  { id: 'manage_posts', label: 'Manage posts' },
  { id: 'pin_posts', label: 'Pin & announce posts' },
  { id: 'set_post_level_gates', label: 'Set level gates' },
  { id: 'manage_comments', label: 'Manage comments' },
  { id: 'manage_members', label: 'Ban & remove members' },
  { id: 'manage_reports', label: 'Moderate reports' },
  { id: 'manage_spam_settings', label: 'Spam & slow mode settings' },
  { id: 'view_audit_log', label: 'View audit log' },
  { id: 'export_members', label: 'Export members CSV' },
  { id: 'export_payments', label: 'Export payments CSV' },
] as const;

export const ALL_COMMUNITY_MODERATOR_PERMISSION_IDS = COMMUNITY_MODERATOR_PERMISSION_OPTIONS.map(
  (option) => option.id,
);

export function hasModeratorCapability(
  capabilities: string[] | undefined | null,
  permission: string,
): boolean {
  return Boolean(capabilities?.includes(permission));
}
